import { Box, Link, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { CUSTOMER_SUPPORT_EMAIL } from "helpers/constants";
import useCatalogDetail from "hooks/useCatalogDetail";
import { DesignType, Workflow } from "types/design";

const useStyles = makeStyles(() => ({
  footnote: {
    fontSize: 12,
    lineHeight: "17.5px",
    letterSpacing: 0.5,
    padding: 8,
  },
}));

const Footnotes = ({
  workflow,
  designType,
  isOnDetail = true,
}: {
  workflow: Workflow;
  designType: DesignType;
  isOnDetail?: boolean;
}) => {
  const classes = useStyles();
  const { isCustomPanel } = useCatalogDetail();

  return (
    <Box bgcolor="#FFF" pb={1}>
      {/* FusionPlex */}
      {workflow === Workflow.FUSION && (
        <>
          <Typography className={classes.footnote}>
            *Exons with * indicates exons that are entirely untranslated region
            (UTR), or for which the UTR is targeted.
          </Typography>
          <Box my={1}>
            <Typography className={classes.footnote}>
              † The mutations listed under the Description column are targeted
              by the assay design. De Novo RNA SNV/Indel and Internal Tandem
              Duplication mutation detection are not supported on the Ion
              Torrent Sequencing Platform.
            </Typography>
          </Box>
        </>
      )}
      {/* Catalog Panel of VariantPlex or LiquidPlex on detail section */}
      {workflow !== Workflow.FUSION &&
        designType === DesignType.CATALOG_PANEL &&
        isOnDetail && (
          <Typography className={classes.footnote}>
            * Please contact{" "}
            <Link href={`mailto:${CUSTOMER_SUPPORT_EMAIL}`} target="_top">
              {CUSTOMER_SUPPORT_EMAIL}
            </Link>{" "}
            to inquire about enabling additional genes for CNV
          </Typography>
        )}
      {/* Gene Module of VariantPlex or LiquidPlex on detail section */}
      {workflow !== Workflow.FUSION &&
        designType === DesignType.GENE_MODULE &&
        isOnDetail && (
          <Typography className={classes.footnote}>
            * Module may be enabled for CNV at panel customization
          </Typography>
        )}
      {/* VariantPlex or LiquidPlex on find module section */}
      {workflow !== Workflow.FUSION && !isOnDetail && !isCustomPanel && (
        <Typography className={classes.footnote}>
          * Gene modules with a toggle may be enabled for CNV detection
        </Typography>
      )}
      {/* Custom Panel of VariantPlex or LiquidPlex on detail section */}
      {workflow !== Workflow.FUSION && isCustomPanel && (
        <Typography className={classes.footnote}>
          Modules may be enabled for CNV at panel customization. For catalog
          panels, please contact{" "}
          <Link href={`mailto:${CUSTOMER_SUPPORT_EMAIL}`} target="_top">
            {CUSTOMER_SUPPORT_EMAIL}
          </Link>{" "}
          to inquire about enabling additional genes for CNV detection.
        </Typography>
      )}
    </Box>
  );
};

export default Footnotes;
